import React from 'react'
import type { IconProps } from '@strata-monorepo/shared-ui/types/Svg'

const Pin = ({ classNames, ...props }: IconProps): React.ReactElement => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='8'
    height='10'
    viewBox='0 0 8 10'
    fill='currentColor'
    className={classNames}
    {...props}
  >
    <path
      d='M4 9.82998C3.88333 9.82998 3.76667 9.80915 3.65 9.76748C3.53333 9.72581 3.42917 9.66331 3.3375 9.57998C2.79583 9.07998 2.31667 8.59248 1.9 8.11748C1.48333 7.64248 1.13542 7.18206 0.85625 6.73623C0.577083 6.2904 0.364583 5.86123 0.21875 5.44873C0.0729167 5.03623 0 4.64248 0 4.26748C0 3.01748 0.402083 2.02165 1.20625 1.27998C2.01042 0.538314 2.94167 0.16748 4 0.16748C5.05833 0.16748 5.98958 0.538314 6.79375 1.27998C7.59792 2.02165 8 3.01748 8 4.26748C8 4.64248 7.92708 5.03623 7.78125 5.44873C7.63542 5.86123 7.42292 6.2904 7.14375 6.73623C6.86458 7.18206 6.51667 7.64248 6.1 8.11748C5.68333 8.59248 5.20417 9.07998 4.6625 9.57998C4.57083 9.66331 4.46667 9.72581 4.35 9.76748C4.23333 9.80915 4.11667 9.82998 4 9.82998ZM4 5.16748C4.275 5.16748 4.51042 5.06956 4.70625 4.87373C4.90208 4.6779 5 4.44248 5 4.16748C5 3.89248 4.90208 3.65706 4.70625 3.46123C4.51042 3.2654 4.275 3.16748 4 3.16748C3.725 3.16748 3.48958 3.2654 3.29375 3.46123C3.09792 3.65706 3 3.89248 3 4.16748C3 4.44248 3.09792 4.6779 3.29375 4.87373C3.48958 5.06956 3.725 5.16748 4 5.16748Z'
      fill='currentColor'
    />
  </svg>
)

export default Pin
